import styled from "styled-components"

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -15px;
  width: calc(100% + 30px);
`

export const Col = styled.div`
  width: 50%;
  flex-grow: 1;
  padding: 0 15px;
  @media (max-width: 600px) {
    width: 100%;
    /* add space between columns on mobile */
    & + & {
      margin-top: 20px;
    }
  }
`
